const SEO = [
	{
		page: "home",
		description:
			"I am a graduating Computer Science student at Georgia Tech currently pursuing a Bachelor's Degree. My love of technology is a major reason why I want to pursue a career in the tech sector. With my passion for technology and innovation, I hope to one day see both my personal and professional projects succeed! I am currently pursuing roles that involve programming, technology, research, and leadership.",
		keywords: ["Keefe", "Keefe O", "Keefe Oentoro"],
	},
	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. A lot of these projects were for fun, useful to me, or were an opportunity to learn. Go ahead and check the ones with links out.",
		keywords: ["Keefe", "Keefe O", "Keefe Oentoro"],
	},

	{
		page: "experience",
		description:
			"I have experience in both frontend and backend development through building through the various projects I have completed. Additionally, I have a lot of experience working in teams and collaborating with others to achieve a common goal.",
		keywords: ["Keefe", "Keefe O", "Keefe Oentoro"],
	},
];

export default SEO;
